/*    
<summary>
  This functional component "Device Status Filter" renders the filter form.
  Developer:Aashish Singh, Created Date: 17-April-2024
</summary>
<returns>Returns JSX</returns>
*/

import React from "react";
import { observer } from "mobx-react";
import { Formik, Field, Form } from "formik";
import { FormattedMessage } from "react-intl";
import LoaderButton from "../../../shared-components/Button/LoaderButton";
import FormikFormSelect from "../../../shared-components/FormikFormHandlers/FormikFormSelect";
import Label from "../../../shared-components/Label/Label";
import FormikFormInput from "../../../shared-components/FormikFormHandlers/FormikFormInput";
import { deviceStatusSearchByOptions, fotaStatusOptions } from "../../../constants/common-constants";
import { fotaDeviceStatusFilterValidationSchema } from "../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import { Modal } from "react-bootstrap";
import { formatMessage } from "../../../translations/format-message";
import { IFotaDeviceStatusFilterDetails } from "../../../models/response/IFotaResponse";

interface IProps {
  initialValues: any;
  submitHandler: (values: IFotaDeviceStatusFilterDetails) => void;
  isFilterActive: boolean;
  modalClosed: () => void;
}

const FotaDeviceStatusFilterForm = (props: IProps) => {
  return (
    <Modal
        className="fancy-modal"
        show={true}
        centered={false}
        size="sm"
        onHide={() => {}}
      >
        <Modal.Header>
          <Modal.Title>
            <FormattedMessage id="filter" />
          </Modal.Title>
          <button
            onClick={props.modalClosed}
            data-testid="Close"
            className="Crossicons"
            title={formatMessage("close")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="bi bi-x"
              viewBox="0 0 16 16"
            >
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </button>
        </Modal.Header>
        <div className="p-0">
        <Formik
            initialValues={props.initialValues}
            enableReinitialize
            validateOnBlur={false}
            validationSchema={fotaDeviceStatusFilterValidationSchema}
            onSubmit={async (values: IFotaDeviceStatusFilterDetails) => {
              let tempValues: IFotaDeviceStatusFilterDetails = {
                SearchBy: values.SearchBy,
                ICCID: values.SearchBy == 1 ? values.ICCID : "",
                Status:
                  values.SearchBy == 2
                    ? typeof values.Status === "string"
                      ? parseInt(values.Status)
                      : values.Status
                    : 0,
              };
              props.submitHandler({ ...tempValues });
            }}
          >
            {({ values }) => {
              return (
                <Form className="user-form p-3">
                  <div className="form-group row">
                    <Label
                      className="label-style col-sm-5 col-form-label"
                      required={true}
                      label="search_by"
                    />
                    <div className="col-sm-7">
                      <Field
                        name="SearchBy"
                        as={FormikFormSelect}
                        options={deviceStatusSearchByOptions}
                      />
                    </div>
                  </div>

                  <div className="">
                    {values.SearchBy == 1 && (
                      <div className="form-group row">
                        <Label
                          className="col-sm-5 label-style"
                          required={true}
                          label="iccid"
                        />
                        <div className="col-sm-7">
                          <Field
                            data-testid="ICCID"
                            className="form-control"
                            name="ICCID"
                            placeholder="iccid"
                            type="number"
                            as={FormikFormInput}
                          />
                        </div>
                      </div>
                    )}
                    {values.SearchBy == 2 && (
                      <div className="form-group row">
                        <Label
                          className="col-sm-5"
                          required={true}
                          label="status"
                        />
                        <div className="col-sm-7">
                          <Field
                            data-testid="Status"
                            id="custom"
                            className="form-control"
                            name="Status"
                            as={FormikFormSelect}
                            options={fotaStatusOptions}
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="d-flex justify-content-end pb-2">
                    <button
                      data-testid="apply"
                      className="btn btn-secondary"
                      type="button"
                      onClick={props.modalClosed}
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <FormattedMessage id="button_cancel" />
                    </button>

                    <LoaderButton type="submit" className="ms-2" text="apply" />
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </Modal>
  );
};

export default observer(FotaDeviceStatusFilterForm);
